// extracted by mini-css-extract-plugin
module.exports = {"sideCartEmpty":"SideCartEmpty_sideCartEmpty__oLFdc","title":"SideCartEmpty_title__w8ORe","text":"SideCartEmpty_text__WnQpw","button":"SideCartEmpty_button__9_reg"};